import React from 'react';

export const TickLogo = () => {
  return (
    <svg width="93" height="93" viewBox="0 0 93 93" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_1471_4186)">
        <rect width="93" height="93" fill="white" />
        <mask
          id="mask0_1471_4186"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="93"
          height="93"
        >
          <path d="M93 0H0V93H93V0Z" fill="white" />
        </mask>
        <g mask="url(#mask0_1471_4186)">
          <mask
            id="mask1_1471_4186"
            style={{ maskType: 'luminance' }}
            maskUnits="userSpaceOnUse"
            x="-19"
            y="-24"
            width="152"
            height="153"
          >
            <path d="M-19 -23.9492H133V128.051H-19V-23.9492Z" fill="white" />
          </mask>
          <g mask="url(#mask1_1471_4186)">
            <mask
              id="mask2_1471_4186"
              style={{ maskType: 'luminance' }}
              maskUnits="userSpaceOnUse"
              x="-20"
              y="-24"
              width="153"
              height="153"
            >
              <path d="M-19.002 -23.9492H132.998V128.051H-19.002V-23.9492Z" fill="white" />
            </mask>
            <g mask="url(#mask2_1471_4186)">
              <path
                d="M16.9071 35.1367C17.6955 35.1367 18.3356 35.5675 18.3356 36.0981C18.3356 36.6287 17.6955 37.0594 16.9071 37.0594C16.1187 37.0594 15.4785 36.6287 15.4785 36.0981C15.4785 35.5675 16.1187 35.1367 16.9071 35.1367Z"
                fill="#FFD13B"
              />
              <g opacity="0.99999">
                <path
                  d="M66.6746 30.0586L66.8477 31.5203L64.8356 33.0092L64.6625 31.5475L66.6746 30.0586Z"
                  fill="#FFB53B"
                />
              </g>
              <path
                d="M65.2598 62.1095L65.8485 63.8023L63.7772 64.9616L63.1885 63.2687L65.2598 62.1095Z"
                fill="#71E183"
              />
              <g opacity="0.999994">
                <path
                  d="M9.19466 85.23L9.72625 86.9549L7.57024 88.2355L7.03864 86.5106L9.19466 85.23Z"
                  fill="#FFC33B"
                />
              </g>
              <path
                d="M33.5293 29.631L33.8997 31.2273L31.8232 32.5894L31.4529 30.9931L33.5293 29.631Z"
                fill="#FFAE3B"
              />
              <g opacity="0.99999">
                <path
                  d="M88.112 49.7386L88.5709 51.0655L86.9456 51.978L86.4868 50.6511L88.112 49.7386Z"
                  fill="#FFCA3B"
                />
              </g>
              <path
                d="M35.3488 49.2701L36.2423 50.8051L34.6041 51.3328L33.7106 49.7978L35.3488 49.2701Z"
                fill="#FF533B"
              />
              <path d="M26.7546 38.7806L28.1142 34.3619L30.8628 36.66L26.7546 38.7806Z" fill="#FF613B" />
              <path d="M84.424 73.1015L86.0306 68.6166L88.5536 70.7261L84.424 73.1015Z" fill="#FF6F3B" />
              <g opacity="0.999994">
                <path
                  d="M34.2578 7.57668L34.9463 9.84432L32.105 11.5428L31.4164 9.2752L34.2578 7.57668Z"
                  fill="#71E183"
                />
              </g>
              <g opacity="0.999999">
                <path
                  d="M94.5934 22.2448L95.3361 25.1223L91.6432 27.4683L90.9005 24.5908L94.5934 22.2448Z"
                  fill="#FFCA3B"
                />
              </g>
              <g opacity="0.999994">
                <path d="M19.5939 60.6686L19.5371 58.2602L21.9743 60.298L19.5939 60.6686Z" fill="#FCC852" />
              </g>
              <path d="M66.8039 23.5538L67.6127 20.0684L70.0909 22.1405L66.8039 23.5538Z" fill="#FCCE52" />
              <path d="M37.9733 88.0225L38.4161 85.4303L40.4461 87.1276L37.9733 88.0225Z" fill="#FCB652" />
              <g opacity="0.999992">
                <path d="M73.2271 35.8709L73.7093 32.7114L76.2512 34.8368L73.2271 35.8709Z" fill="#FCB652" />
              </g>
              <g opacity="0.999994">
                <path
                  d="M90.466 22.2458C88.2053 21.208 86.9006 18.0519 86.3594 14.2578"
                  stroke="#FCD452"
                  stroke-width="3.81107"
                />
              </g>
              <path
                d="M57.0289 81.7641C58.0748 83.9431 60.5016 84.6661 63.2441 85.0859"
                stroke="#71E183"
                stroke-width="5.11559"
              />
              <path
                d="M55.4178 20.3701C51.81 18.1715 47.3956 18.8127 43.0639 19.3829"
                stroke="#FCA452"
                stroke-width="3.95815"
              />
              <g opacity="0.999992">
                <path
                  d="M69.7303 64.056C72.5193 63.4939 74.2334 61.5759 75.7695 59.6328"
                  stroke="#FFAE3B"
                  stroke-width="0.216746"
                />
              </g>
              <g opacity="0.99999">
                <path
                  d="M9.33789 89.8047C6.06319 88.5067 4.34455 86.7331 6.88955 85.1749C7.62707 84.7232 8.28946 84.4273 8.88187 84.2664"
                  stroke="#FCB652"
                  stroke-width="3.9171"
                />
              </g>
              <path
                d="M8.0706 18.486C11.3528 17.8453 18.2619 11.4452 16.0608 8.42229"
                stroke="#FFAE3B"
                stroke-width="2.00486"
              />
            </g>
            <mask
              id="mask3_1471_4186"
              style={{ maskType: 'luminance' }}
              maskUnits="userSpaceOnUse"
              x="-20"
              y="-24"
              width="153"
              height="153"
            >
              <path d="M132.998 128.055H-19.002V-23.9453H132.998V128.055Z" fill="white" />
            </mask>
            <g mask="url(#mask3_1471_4186)">
              <g opacity="0.89398">
                <path
                  d="M68.6387 50.3984C68.1893 50.3984 67.8243 50.0746 67.8243 49.6758C67.8243 49.277 68.1893 48.9532 68.6387 48.9532C69.0882 48.9532 69.4531 49.277 69.4531 49.6758C69.4531 50.0746 69.0882 50.3984 68.6387 50.3984Z"
                  fill="#FFAC23"
                />
              </g>
              <path
                d="M82.7936 37.1345L81.5394 37.9531L79.724 36.5962L80.9782 35.7776L82.7936 37.1345Z"
                fill="#FF9C23"
              />
              <path
                d="M37.3817 56.6871L35.077 57.2547L30.8541 54.9552L33.1589 54.3877L37.3817 56.6871Z"
                fill="#FF9C23"
              />
              <g opacity="0.89398">
                <path
                  d="M62.9311 60.9014L60.834 62.8958L58.3908 60.4973L60.4879 58.5029L62.9311 60.9014Z"
                  fill="#71E183"
                />
              </g>
              <g opacity="0.89398">
                <path d="M39.4903 49.3609L41.1562 48.7861L40.4023 50.869L39.4903 49.3609Z" fill="#FFB423" />
              </g>
              <path
                d="M25.1762 22.3509C25.2077 21.4495 25.9253 20.7417 26.7778 20.7715C27.6302 20.8012 28.2967 21.5573 28.2652 22.4588C28.2338 23.3603 27.5161 24.0681 26.6637 24.0383C25.8112 24.0085 25.1447 23.2524 25.1762 22.3509Z"
                fill="#FFA423"
              />
              <path
                d="M40.5245 62.8743L38.134 63.9519L34.2169 61.4656L36.6074 60.388L40.5245 62.8743Z"
                fill="#71E183"
              />
              <path
                d="M55.9219 20.452L53.6195 21.6296L49.9789 19.2059L52.2814 18.0283L55.9219 20.452Z"
                fill="#FCC252"
              />
              <g opacity="0.349193">
                <path d="M55.0199 35.18L57.6081 34.1202L56.33 37.6509L55.0199 35.18Z" fill="#FCB052" />
              </g>
              <path d="M36.7372 72.4649L40.4861 71.0916L38.7383 75.9197L36.7372 72.4649Z" fill="#71E183" />
              <g opacity="0.999988">
                <path d="M58.7301 54.1077L63.0396 54.2652L62.1419 56.7452L58.7301 54.1077Z" fill="#71E183" />
              </g>
              <g opacity="0.89398">
                <path
                  d="M57.0242 51.318C56.7897 48.55 56.5544 41.3999 59.5702 35.6619C60.7684 33.3824 59.3669 31.2119 57.209 30.0273"
                  stroke="#71E183"
                  stroke-width="6.47321"
                />
              </g>
              <g opacity="0.349193">
                <path
                  d="M57.2643 52.0964C57.2643 52.0964 55.3264 55.5011 53.4785 56.2852"
                  stroke="#71E183"
                  stroke-width="3.59003"
                />
              </g>
            </g>
          </g>
          <mask
            id="mask4_1471_4186"
            style={{ maskType: 'luminance' }}
            maskUnits="userSpaceOnUse"
            x="14"
            y="14"
            width="67"
            height="67"
          >
            <path d="M14.0938 14.0977H80.0036V80.0075H14.0938V14.0977Z" fill="white" />
          </mask>
          <g mask="url(#mask4_1471_4186)">
            <g opacity="0.0587513">
              <path
                d="M46.9192 15.418C64.0147 15.418 77.895 29.2982 77.895 46.3938C77.895 63.4893 64.0147 77.3696 46.9192 77.3696C29.8236 77.3696 15.9434 63.4893 15.9434 46.3938C15.9434 29.2982 29.8236 15.418 46.9192 15.418Z"
                fill="#22A55F"
              />
            </g>
            <g opacity="0.608103">
              <path
                d="M46.9209 19.9805C61.5598 19.9805 73.4454 31.8661 73.4454 46.5049C73.4454 61.1437 61.5598 73.0293 46.9209 73.0293C32.2821 73.0293 20.3965 61.1437 20.3965 46.5049C20.3965 31.8661 32.2821 19.9805 46.9209 19.9805Z"
                fill="#22A55F"
              />
            </g>
            <g opacity="0.818655">
              <path
                d="M46.92 23.8125C59.4952 23.8125 69.7052 34.0226 69.7052 46.5977C69.7052 59.1729 59.4952 69.3829 46.92 69.3829C34.3448 69.3829 24.1348 59.1729 24.1348 46.5977C24.1348 34.0226 34.3448 23.8125 46.92 23.8125Z"
                fill="#22A55F"
              />
            </g>
            <path
              d="M46.9215 23.6641C59.5805 23.6641 69.8586 33.9422 69.8586 46.6012C69.8586 59.2602 59.5805 69.5383 46.9215 69.5383C34.2625 69.5383 23.9844 59.2602 23.9844 46.6012C23.9844 33.9422 34.2625 23.6641 46.9215 23.6641Z"
              fill="#22A55F"
            />
            <path
              d="M36.4297 47.6345L43.0593 54.1354L56.4472 40.2969"
              stroke="white"
              stroke-width="3.8619"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </g>
        </g>
      </g>
      <defs>
        <clipPath id="clip0_1471_4186">
          <rect width="93" height="93" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
